<template>
  <v-col class="pt-5 pb-0">
    <v-autocomplete v-model="newFilters" prepend-inner-icon="mdi-magnify" :items="childrens" item-text="name"
      :label="$t('search')" chips closable-chips multiple dense rounded outlined return-object @change="handleFilters">
      <template v-slot:item="{ item, on, attrs }">
        <v-list-item v-bind="attrs" v-on="on">
          <v-list-item-content>
            <v-list-item-title>
              {{ item.name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:selection="{ item, index }">
        <v-chip :key="index" close @click:close="removeItem(item)">
          {{ item.name }}
        </v-chip>
      </template>
    </v-autocomplete>
  </v-col>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SearchBar',
  data() {
    return {
      newFilters: [],
    }
  },
  computed: {
    ...mapGetters({
      categories: 'categories/getCategories',
      brands: 'brands/getBrands',
    }),
    childrens() {
      const brands = this.brands.map(el => ({ ...el, type: 'b' }))
      const categories = this.categories.map(el => ({ ...el, type: 'c' }))
      return [...brands, ...categories]
    }
  },
  methods: {
    removeItem(item) {
      this.newFilters = this.newFilters.filter(
        filter => filter.id !== item.id
      )
      this.handleFilters(this.newFilters)
    },
    handleFilters(filters) {
      const brandIds = filters.filter(f => f.type === 'b').map(f => f.id)
      const categoryIds = filters.filter(f => f.type === 'c').map(f => f.id)
      this.$router.push({
        query: {
          ...this.$route.query,
          brand_id: brandIds.length ? brandIds : undefined,
          category_id: categoryIds.length ? categoryIds : undefined
        }
      })
    }
  }
}
</script>

<style>
.v-text-field,
.v-text-field:-webkit-autofill,
.v-text-field:-webkit-autofill:hover,
.v-text-field:-webkit-autofill:focus,
.v-text-field:-webkit-autofill:active {
  -webkit-text-fill-color: black !important;
}
</style>